<template>
  <div style="display: flex; flex-direction: column; gap: 10px">
    <div
        v-if="isFiltersOpen"
        style="
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 40px;
          "
    >
      <div>
        <span style="margin-right: 10px">Alarm ID</span>
        <InputText v-model="alarmPointId" placeholder="Filter by Alarm ID"/>
      </div>

      <div>
        <span style="margin-right: 10px">System ID</span>
        <InputText v-model="systemId" placeholder="Filter by System ID"/>
      </div>
    </div>
    <DataTable :value="repeatableAlarms"
               :paginatorTemplate="'FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink'"
               :paginator="true"
               :page="apCurrentPage"
               :dataKey="tableDataKey"
               :rows="alarmPointRows"
               :scrollable="true"
               :lazy="true"
               :totalRecords="apTotalRecords"
               @page="setApCurrentPage"
               class="tight"
    >
      <Column
          header="Alarm ID"
          :style="'width: 100%' + '%; word-break: break-all; min-height: 38px;'"
          field="alarmPointId"
          header-style="padding-left: 19px!important;"
      >
        <template #body="slotProps">
            <span style="word-break: break-all; padding-left: 5px"
            >
              {{ slotProps.data.alarmPointId }}
            </span>

        </template>
      </Column>
      <Column
          header="System ID"
          style="width: 100%; word-break: break-all; min-height: 38px;"
          field="systemId"
          header-style="padding-left: 19px!important;"
      >
        <template #body="slotProps">
            <span style="text-align: center; word-break: break-all; padding-left: 5px"
            >
              {{ slotProps.data.systemId }}
            </span>

        </template>
      </Column>
      <Column
          header="Name"
          style="width: 100%; word-break: break-all; min-height: 38px;"
          field="name"
          header-style="padding-left: 19px!important;"
      >
        <template #body="slotProps">
            <span style="text-align: center; word-break: break-all; padding-left: 5px"
            >
              {{ slotProps.data.name }}
            </span>

        </template>
      </Column>
      <template #empty> No alarms found</template>
    </DataTable>
  </div>
</template>

<script>
import {debounce} from "lodash";
import {getRepeatableCandidates} from "@/api/manage-alarms";

export default {
  name: "license",
  props: {
    isFiltersOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      alarmPointId: "",
      systemId: "",
      repeatableAlarms: [],
      isLoading: false,
      alarmPointRows: 15,
      apCurrentPage: 0,
      apTotalRecords: 0,
      tableDataKey: null,
    };
  },
  created() {
    this.debouncedFilterUpdate = debounce(this.getRepeatableMonitoredAlarms, 500);
  },
  mounted() {
    this.getRepeatableMonitoredAlarms();
  },
  watch: {
    alarmPointId() {
      this.debouncedFilterUpdate();
    },
    systemId() {
      this.debouncedFilterUpdate();
    },
  },
  methods: {
    getRepeatableMonitoredAlarms() {
      this.isLoading = true;
      return getRepeatableCandidates().then((response) => {
        this.repeatableAlarms = response.data;
        this.isLoading = false;
      });
    },
    setApCurrentPage({ page }) {
      this.apCurrentPage = page;
      this.isLoading = true;
      this.getRepeatableMonitoredAlarms();
    },
  },
};
</script>
